<div
  class="review-body-container mx-auto flex w-full flex-col items-center justify-center px-4 py-5 lg:px-0 lg:py-6">
  <h1 class="review-body-title mt-0 mb-5 text-center">
    {{ 'transfer_v2.review.title' | translate }}
  </h1>

  <div
    *ngIf="loyaltyProgramImageUrl()"
    class="loyalty-program-image-container space-between flex w-full items-center justify-center">
    <div
      class="loyalty-program-image-wrapper flex h-full w-full items-center justify-center">
      <img
        class="loyalty-program-image content max-h-full max-w-full object-contain"
        [src]="brandIconUrl"
        alt="" />
    </div>

    <rd-shared-icon
      class="transfer-icon mx-5 my-0 h-4 w-4 flex-shrink-0"
      [iconSymbol]="'icon-icn-transfer'"
      [iconTheme]="'link'"
      [iconOptions]="flippableIconOptions"></rd-shared-icon>

    <div
      class="loyalty-program-image-wrapper flex h-full w-full items-center justify-center">
      <img
        class="loyalty-program-image content max-h-full w-full max-w-full object-contain"
        [src]="loyaltyProgramImageUrl()"
        alt="" />
    </div>
  </div>
  <rd-tcv2-review-breakdown
    class="w-full"
    [formData]="formData"
    [promocode]="promocode"
    [loyaltyProgram]="loyaltyProgram">
  </rd-tcv2-review-breakdown>
  <div class="review-body-information flex w-full flex-col pt-3">
    <rd-shared-dynamic-list
      [items]="pointsTransferDetails"></rd-shared-dynamic-list>
  </div>
</div>
